import { useRef } from 'react';
import html2canvas from 'html2canvas';
import { Table } from 'antd';

import type { ColumnsType } from 'antd/es/table';

import ButtonSimple from '@/components/ButtonSimple';
import TooltipCustom from '@/components/TooltipCustom';
import { IconAiOutlineDownload } from '@/utils/icons';

interface TableDataType {
  key: string;
  region: string;
  numberOfEvents: number;
  children?: TableDataType[];
}

const PivotTableV1 = ({ item }: any) => {

  const pivotDataAll: any = item?.data || [];
  const headers = item?.headers || [];
  const tableRefPivotTableV1 = useRef<HTMLDivElement>(null);

  const transformDataForTable = (): TableDataType[] => {

    if (!pivotDataAll || !pivotDataAll) {
      return [];
    }

    const tableData: TableDataType[] = [];

    pivotDataAll.forEach((regionData: any, regionIndex: number) => {
      const regionRow: TableDataType = {
        key: `region-${regionIndex}`,
        region: regionData.parent_key,
        numberOfEvents: regionData.parent_key_value,
        children: []
      };

      // Create child rows for each country
      regionData.child_data.forEach((countryData: any, countryIndex: number) => {
        const countryRow: TableDataType = {
          key: `country-${regionIndex}-${countryIndex}`,
          region: countryData.child_key,
          numberOfEvents: countryData.child_key_value
        };

        regionRow.children!.push(countryRow);
      });

      tableData.push(regionRow);
    });

    return tableData;

  };


  const columns: ColumnsType<TableDataType> = [
    {
      title: headers[0],
      dataIndex: 'region',
      key: 'region',
      className: 'text-[10px] !text-left !p-[4px] ',
      width: 250,
      render: (text: any, record: TableDataType) => {
        if (record.children) {
          return <span className="text-[10px] !text-center !p-[4px] ">{text == '0' || text == 0 ? '' : text}</span>;
        }
        return text || '';
      }
    },
    {
      title: headers[1],
      dataIndex: 'numberOfEvents',
      key: 'numberOfEvents',
      className: 'text-[10px] !text-center !p-[4px] ',
      width: 150,
      align: 'center',
      render: (value: any, record: TableDataType) => {
        if (record.children) {
          return <span className="text-[10px] !text-center !p-[4px] ">{value == '0' || value == 0 ? '' : value}</span>;
        }
        return value || '';
      }
    }
  ];

  const tableData = transformDataForTable();

  const grandTotal = pivotDataAll.reduce((sum: number, region: any) => sum + region.parent_key_value, 0);

  const exportAsPNG = async () => {
    if (tableRefPivotTableV1.current) {
      const canvas = await html2canvas(tableRefPivotTableV1.current, { scale: 2 });
      const link = document.createElement('a');
      link.download = `${item?.title || 'table'}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    }
  };

  return (
    <div>

      <div>
        <TooltipCustom title="Export as PNG">
          <ButtonSimple
            onClick={exportAsPNG}
            className='flex justify-self-end mb-1'
          >
            <IconAiOutlineDownload />
          </ButtonSimple>
        </TooltipCustom>
      </div>
      <div className="w-full overflow-x-auto" ref={tableRefPivotTableV1 as any}>
        <p className=" text-xl font-semibold leading-none tracking-tight base-card-title !text-center w-full mb-3 ">{item?.title}</p>
        <Table
          columns={columns}
          dataSource={tableData}
          pagination={false}
          style={{
            padding: 0,
            fontSize: 10,
            margin: 0
          }}
          bordered
          size="small"
          // scroll={{ y: '600px' }}
          defaultExpandAllRows={true}
          className="ant-table-striped p-0 !text-[8px]"
          summary={() => (
            <Table.Summary fixed>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0}>
                  <strong>Total</strong>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} align="center">
                  <strong>{grandTotal}</strong>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          )}
          rowClassName={(record, index) => {
            if (record.children) {
              return 'bg-gray-50 font-semibold';
            }
            return index % 2 === 0 ? 'bg-white' : 'bg-gray-25';
          }}
        />
      </div>
    </div>
  );
};

export default PivotTableV1;